/* eslint-disable max-len */
/* eslint-disable camelcase */
export const social_auth = {
    messages: {
        registration_exists: 'User with this email already exists. Please sign in to connect to this account',
        login_exists: 'Please sign in via email once to connect to this account',
        question: 'Please sign in once to connect to your account'
    }
};
